import React, { useState, useEffect } from 'react'
import cloudscape from '../../assets/ai-cloudscape.png'
import magkeyLogo from '../../assets/magkey-logo.png'
import './index.scss'
import { Form, Button, message } from 'antd';
import { ExclamationCircleOutlined, LeftOutlined  } from '@ant-design/icons';
import ImageCodeCheck from "../../components/ImageCodeCheck";
import MessageCodeCheck from "../../components/MessageCodeCheck";
import ChangePassword from "../../components/ChangePassword";
import AutoBack from "../../components/AutoBack";
import { apiGetCaptcha, 
         apiCheckImageCode, 
         apiSendPhoneCode, 
         apiUpdatePassword 
        } from '../../request/api';
import {useForm} from "antd/es/form/Form";
import {messageTips} from "../../utils";

function Password(props) {
    const [captcha, setCaptcha] = useState('')
    const [captchaImg, setCaptchaImg] = useState('')
    const [curStep, setCurStep] = useState(0)
    const [btnDisabled, setBtnDisabled] = useState(false);
    const [btnText, setBtnText] = useState('发送验证码')
    const [phoneNumber, setPhoneNumber] = useState('')
    const [nextShow, setNextShow] = useState(true);
    const [codeId,setCodeId] = useState("");
    const [phoneCodeId,setPhoneCodeId] = useState("");
    const [phoneCode,setPhoneCode] = useState("");

    //const titlesArr = ['请输入您的手机号和验证码', '身份验证', '设置新密码', '新密码设置成功！']
    const [form] = useForm();
    // 获取图片验证码
    const getCaptcha = () => {
        apiGetCaptcha().then(res => {
            // console.log(res)
            if(res.data.IsSuccess){
                setCaptchaImg(res.data.data.Base64Stream)
                setCaptcha(res.data.data.Code)
                setCodeId(res.data.data.Identifying);
            } else {
               messageTips(res.data.msg,'error')
            }
        }).catch(err => {
            console.log(err)
        })
    }

    // 图片验证码切换
    const handleClick = () => {
        getCaptcha()
    }

    // 按钮倒计时
    const countDown = () => {
        setBtnDisabled(true)
        let countTime = 60
        const timerId = setInterval(() => {
            if(document.getElementById('MessageCode') === null){
                clearInterval(timerId)
                return
            }
            if(countTime > 0){
                -- countTime
                setBtnText(countTime + '秒后重新获取')
            } else {
                clearInterval(timerId)
                setBtnDisabled(false)
                setBtnText('发送验证码')
            }
        }, 1000)
    }

    // 发送短信验证码
    const sendMessage = () => {
        const params = {
            F_Phone: phoneNumber,
            Identifying: "",
            Type: "updatePassword",
            F_PhoneCode: ""
        }
        apiSendPhoneCode(params).then(res => {
            if(res.data.IsSuccess){
                setPhoneCodeId(res.data.data);
                messageTips('验证码发送成功','success')
                countDown()
            } else {
                messageTips(res.data.msg,'error')
            }
        }).catch(err => {
           messageTips(err,'error')
        })
    }

    const nextAndSubmit = ()=> {
        switch(curStep){
            case 0:
                // 保存手机号
                form.validateFields().then(params=> {
                    setPhoneNumber(params.Phone);
                    params.Identifying = codeId;
                    console.log('图片验证码校检参数.......',params)
                    apiCheckImageCode(params).then(res => {
                        if(res.data.IsSuccess){
                            setCurStep(curStep + 1)
                        } else {
                            messageTips('图片验证码校验失败！','error')
                        }
                    }).catch(err => {
                        messageTips(err,'error')
                    })
                })


                break

            case 1:
                form.validateFields().then(params=> {
                    // let msgCodeInfo = {
                    //     F_Phone: params.Phone,
                    //     Identifying: codeId,
                    //     F_PhoneCode: params.MessageCode
                    // }
                    // apiCheckPhoneCode(msgCodeInfo).then(res => {
                    //     if(res.data.IsSuccess){
                    //         setCurStep(curStep + 1)
                    //     } else {
                    //         messageTips(res.data.msg,'error')
                    //     }
                    // }).catch(err => {
                    //     messageTips(err,'error')
                    // })
                    setPhoneCode(params.MessageCode);
                    setCurStep(curStep + 1)
                })


                break

            case 2:
                form.validateFields().then(params=> {
                    console.log("手机验证码:"+phoneCode);
                    let passwordInfo = {
                        F_Phone: phoneNumber,
                        F_Password: params.newPassword,
                        F_ConfirmPassword: params.newPasswordConfirm,
                        PhoneCode: phoneCode,
                        PhoneCodeId: phoneCodeId,
                    }
                    apiUpdatePassword(passwordInfo).then(res => {
                        if(res.data.IsSuccess){
                            message.success(res.data.data)
                            setNextShow(false)
                            setCurStep(curStep + 1)
                        } else {
                            messageTips(res.data.msg,'error')
                        }
                    }).catch(err => {
                        messageTips(err,'error')
                    })
                })


                break

            default:
                return
        }
    }
    useEffect(() => {
        getCaptcha()
    }, [])

    const handleHeroPointerMove = (event) => {
        const x = (event.clientX / window.innerWidth - 0.5) * -18;
        const y = (event.clientY / window.innerHeight - 0.5) * -12;
        event.currentTarget.style.setProperty('--mx', `${x}px`);
        event.currentTarget.style.setProperty('--my', `${y}px`);
    }

    return (
        <div className='password_page_box' onPointerMove={handleHeroPointerMove}>
            <header className='ai-topbar'>
                <div className='ai-brand'>
                    <img src={magkeyLogo} alt='MAGKEY' />
                    <span>麦格凯科技</span>
                </div>
            </header>
            <img className='ai-hero-media' src={cloudscape} alt='' aria-hidden='true' />
            <div className='ai-hero-tint' />
            <div className='ai-particle-field' />
            <div className='ai-hero-inner'>
                <section className='ai-hero-copy' aria-label='找回密码介绍'>
                    <div className='ai-eyebrow'><i /> 安全链接保持</div>
                    <h1>一个入口，<br></br>连接所有工作。</h1>
                    <p>统一身份、安全访问、智能协同。登录后即可进入麦格凯企业应用与数据服务。</p>
                </section>
            <div className='password_box'>
                <div className='password_content_box'>
                    <div className='password-header'>
                        <button className="feed-back" type='button' onClick={()=>{
                            if(curStep === 0){
                                props.history.push(`/login${props.location.search}`)
                            }else{
                                if(curStep === 1 || curStep ===2) {
                                    setBtnDisabled(false);
                                    setBtnText("发送验证码");
                                }
                                setCurStep(curStep-1);
                            }
                        }}><LeftOutlined /></button>
                        <div className='password-heading'>
                            <div className='title'>找回密码</div>
                        </div>
                    </div>
                    <div className='password_form_content'>
                        {
                            nextShow ?
                                <div className="form_tips"><ExclamationCircleOutlined/><span style={{paddingLeft:6}}>请输入您要找回登录密码的账户名</span></div>
                                :""
                        }

                        <div style={{marginTop:10}}>
                            <Form form={form}
                                //onFinish={onFinish}
                            >
                                {(() => {
                                    switch(curStep){
                                        case 0:
                                            return <ImageCodeCheck handleClick={handleClick} captcha={captcha} captchaImg={captchaImg}/>
                                        case 1:
                                            return <MessageCodeCheck sendMessage={sendMessage} btnDisabled={btnDisabled} btnText={btnText}/>
                                        case 2:
                                            return <ChangePassword />
                                        case 3:
                                            return <AutoBack props={props}/>
                                        default:
                                            return ''
                                    }
                                })()}

                            </Form>
                        </div>

                    </div>
                    {
                        nextShow ? (
                            <div >
                                <Button className="password_next_btn" onClick={nextAndSubmit}>
                                    下一步
                                </Button>
                            </div>
                        ) : ''
                    }
                    {/*<div className='step'>*/}
                    {/*    <BasicStep curStep={curStep} stepsData={['填写手机号', '验证身份', '设置新密码', '完成']}/>*/}
                    {/*</div>*/}
                </div>
            </div>
            </div>
            <div className='password-copyright'>
                <p>版权所有 © 2026 麦格凯科技. 保留所有权利。</p>
                <p>Copyright © 2026 MAGKEY Technology. All rights reserved.</p>
            </div>
        </div>
    )
}

export default Password;
